import { Disclosure, Transition } from "@headlessui/react";
import { cva } from "cva";
import Link from "next/link";
import { TrackerNavigationItem } from "~/types/asgard/Tracker";
import { Body, Headline, Icon } from "~/ui-library";
import { ChevronDownIcon, ChevronUpIcon } from "~/ui-library/icons";

export type TrackerInlineNavigationProps = {
  items: TrackerNavigationItem[];
};

const mobileNavStyles = cva(
  [
    "flex items-center justify-between",
    "border-x-0 border-y-1 border-gray-300 px-m py-s md:border-1",
    "transition-colors ease-in-out",
    "w-full",
  ],
  {
    variants: {
      isOpen: {
        true: "bg-white",
        false: "bg-gray-100",
      },
    },
  }
);

/** The inline  navigation element that will collapse/expand as the main button is clicked */
export const TrackerInlineNavigation = ({
  items,
}: TrackerInlineNavigationProps) => (
  <Disclosure>
    {({ open }) => (
      <div>
        <Disclosure.Button className={mobileNavStyles({ isOpen: open })}>
          <Headline as="h6" blockCase level={6}>
            In This Tracker
          </Headline>
          <Icon SvgIcon={open ? ChevronUpIcon : ChevronDownIcon} size="large" />
        </Disclosure.Button>
        <Transition
          enter="transition ease-out duration-fast"
          enterFrom="opacity-0 -translate-y-m"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-fast"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-m"
          unmount={false}
        >
          <Disclosure.Panel
            as="ul"
            className="border-x-0 border-b-1 border-gray-300 px-m py-s md:border-x-1"
            unmount={false}
          >
            {items.map(({ blockId, headline }) => (
              <Body
                as="li"
                bold
                className="mb-m last:mb-0"
                key={blockId}
                size="small"
              >
                <Link href={`#${blockId}`}>{headline}</Link>
              </Body>
            ))}
          </Disclosure.Panel>
        </Transition>
      </div>
    )}
  </Disclosure>
);
